import * as actionTypes from '../../constants/ActionTypes/MyAccount';

const initialState = {
    enrollmentJourneySerialNumber: null
}

const EnrollmentSerialNumber = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.STORE_ACCOUNT_ENROLLMENT_JOURNEY_SERIALNUMBER:
            return {
                ...state,
                enrollmentJourneySerialNumber: action.serialNumber
            }
        case actionTypes.RESET_ACCOUNT_ENROLLMENT_JOURNEY_SERIALNUMBER:
            return {
                ...state,
                enrollmentJourneySerialNumber: null
            }
        default:
            return { ...state }
    }
}

export default EnrollmentSerialNumber;